// HOOKS
import { useMutation } from "@apollo/client";
// GRAPHQL
import { CREATE_ASSET } from "../../graphql/mutations/assets/assets.mutations";

const useCreateAsset = () => {
  const [createAssetMutation, { loading, error, data }] =
    useMutation(CREATE_ASSET);

  const createAsset = async (asset) => {
    try {
      await createAssetMutation(asset);
      return data.createAsset;
    } catch (error) {
      console.error(`Error creating asset: ${error?.message}`);
      alert(`Error creating asset: ${error?.message}`);
    }
  };

  return { createAsset, loading, error };
};

export default useCreateAsset;
